export default {"src":"/_next/static/media/DynamicStrategyIcon.d31aa7f4.svg","height":43,"width":52,"blurWidth":0,"blurHeight":0};